import { render, staticRenderFns } from "./RecentlyViewed.vue?vue&type=template&id=5b7db205"
import script from "./RecentlyViewed.vue?vue&type=script&lang=js"
export * from "./RecentlyViewed.vue?vue&type=script&lang=js"
import style0 from "./RecentlyViewed.vue?vue&type=style&index=0&id=5b7db205&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports